import React from 'react';
import styled from 'styled-components';
import Toast from './Toast';
import { ToastData } from '../../hooks/useToast';

interface ToastContainerProps {
  toasts: ToastData[];
  onClose: (id: string) => void;
}

const Container = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 12px;
  pointer-events: none;
  
  > * {
    pointer-events: auto;
  }
  
  @media (max-width: 768px) {
    left: 20px;
    right: 20px;
  }
`;

const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onClose }) => {
  if (toasts.length === 0) return null;

  return (
    <Container>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          bookingId={toast.bookingId}
          isVisible={true}
          onClose={() => onClose(toast.id)}
        />
      ))}
    </Container>
  );
};

export default ToastContainer;
